// React is imported from react
// style is imported from app.css
import React from 'react';
import '../../App.css';

// mainImage function is created
const MainImage = ({searchText, onSearchChange}) => {
    return(
        <>
        <div class="main-img"></div>
        <h class="catagoryHeader">Top catagory</h>
    </>
    )
};


export default MainImage;